import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  download: {
    maxWidth: 'fit-content',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: 'none',
  },
  container: {
    flex: 1,
    position: 'relative',
    height: 'calc(100vh - 300px)',
  },
  tableWrapper: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    inset: 0,
  },
  table: {
    '&.MuiDataGrid-root': {
      marginBottom: theme.spacing(2),
      borderTopLeftRadius: 0,
    },
    '&.MuiDataGrid-root .MuiDataGrid-columnHeaderDraggableContainer .MuiDataGrid-columnHeaderTitle':
      {
        textOverflow: 'clip',
        whiteSpace: 'break-spaces',
        lineHeight: 1,
      },
    '&.MuiDataGrid-root .MuiDataGrid-row:hover': {
      backgroundColor: theme.palette.baseColors.iceBlue.c50,
    },
    '&.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
      backgroundColor: theme.palette.baseColors.skyBlue.c25,
    },
    '&.MuiDataGrid-root .MuiDataGrid-overlay .MuiCircularProgress-root': {
      color: theme.palette.accentText.color,
    },
  },
}));
